import { pstyle } from "../lib/pstyle.js";
import Hoverable from "../lib/Hoverable.jsx";

export default function Course({ v }) {
  return (
    <div style={pstyle("padding:44px 44px 72px; display:grid; grid-template-columns:minmax(0,1fr) 300px; gap:56px;")}>
      <div style={pstyle("display:flex; flex-direction:column; gap:36px;")}>
        <div style={pstyle("display:flex; flex-direction:column; gap:14px;")}>
          <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11.5px; letter-spacing:0.1em; text-transform:uppercase; color:oklch(0.46 0.075 55);")}>{v.courseModuleLabel}</span>
          <h1 style={pstyle("margin:0; font-size:34px; font-weight:600; letter-spacing:-0.025em;")}>{v.courseTitle}</h1>
          <p style={pstyle("margin:0; font-size:16px; line-height:1.7; color:oklch(0.42 0.015 60); max-width:62ch; text-wrap:pretty;")}>{v.courseDesc}</p>
          <div style={pstyle("display:flex; align-items:center; gap:20px; font-size:13px; color:oklch(0.5 0.015 60);")}>
            {v.courseMeta}
          </div>
        </div>

        <div style={pstyle("display:flex; flex-direction:column;")}>
          {v.lessons.map((l, i) => (
            <Hoverable
              key={i}
              onClick={l.onClick}
              style={pstyle("display:flex; align-items:center; gap:16px; padding:15px 4px; border-bottom:1px solid oklch(0.95 0.006 85); cursor:pointer;")}
              hoverStyle={{ background: "oklch(0.985 0.005 85)" }}
            >
              <span style={pstyle("width:22px; height:22px; flex:none; border-radius:50%; display:flex; align-items:center; justify-content:center; font-family:'IBM Plex Mono', monospace; font-size:11px;", { border: "1px solid " + l.ring, background: l.fill, color: l.numColor })}>{l.mark}</span>
              <div style={pstyle("display:flex; flex-direction:column; gap:2px;")}>
                <span style={pstyle("font-size:15px;")}>{l.title}</span>
                <span style={pstyle("font-size:12.5px; color:oklch(0.55 0.015 60);")}>{l.kind}</span>
              </div>
              <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:11.5px; color:oklch(0.56 0.015 60);")}>{l.dur}</span>
              <span style={pstyle("font-size:12.5px; width:96px; text-align:right; color:oklch(0.46 0.075 55);")}>{l.state}</span>
            </Hoverable>
          ))}
        </div>

        <div style={pstyle("display:flex; flex-direction:column; gap:14px;")}>
          <h2 style={pstyle("margin:0; font-size:20px; font-weight:600; letter-spacing:-0.015em;")}>Quiz de validation</h2>
          <div style={pstyle("border:1px solid oklch(0.93 0.008 85); border-radius:9px; padding:24px 26px; display:flex; flex-direction:column; gap:16px;")}>
            <div style={pstyle("display:flex; align-items:baseline; gap:10px;")}>
              <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11.5px; color:oklch(0.53 0.015 60);")}>{v.quizCounter}</span>
              <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:11.5px; color:oklch(0.53 0.015 60);")}>Score requis : 70 %</span>
            </div>
            <p style={pstyle("margin:0; font-size:16px; line-height:1.6; text-wrap:pretty;")}>{v.quizQuestion}</p>
            <div style={pstyle("display:flex; flex-direction:column; gap:8px;")}>
              {v.quizChoices.map((c, i) => (
                <button key={i} type="button" onClick={c.onClick} style={pstyle("background:none; font:inherit; text-align:left; width:100%; border-radius:7px; padding:12px 14px; font-size:14.5px; display:flex; align-items:center; gap:12px; cursor:pointer;", { border: "1px solid " + c.border, background: c.bg })}>
                  <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11.5px; color:oklch(0.53 0.015 60);")}>{c.k}</span>
                  <span>{c.label}</span>
                  <span style={pstyle("margin-left:auto; font-size:12.5px;", { color: c.markColor })}>{c.mark}</span>
                </button>
              ))}
            </div>
            <div style={pstyle("display:flex; align-items:center; gap:14px; padding-top:4px;")}>
              <button type="button" onClick={v.quizPrimary} style={pstyle("border:none; font:inherit; font-size:13.5px; background:oklch(0.24 0.012 60); color:oklch(0.98 0.005 85); padding:9px 18px; border-radius:7px; cursor:pointer;")}>{v.quizButton}</button>
              <span style={pstyle("font-size:13.5px;", { color: v.quizFeedbackColor })}>{v.quizFeedback}</span>
            </div>
          </div>
        </div>
      </div>

      <aside style={pstyle("display:flex; flex-direction:column; gap:26px;")}>
        <div style={pstyle("border:1px solid oklch(0.93 0.008 85); border-radius:9px; padding:20px; display:flex; flex-direction:column; gap:12px;")}>
          <div style={pstyle("display:flex; align-items:baseline; gap:8px;")}>
            <span style={pstyle("font-size:13px; font-weight:600;")}>Progression du module</span>
            <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:12px; color:oklch(0.46 0.075 55);")}>{v.modulePct}%</span>
          </div>
          <div style={pstyle("height:4px; border-radius:2px; background:oklch(0.94 0.006 85); overflow:hidden;")}>
            <div style={pstyle("height:100%; background:oklch(0.46 0.075 55);", { width: v.modulePct + "%" })}></div>
          </div>
          <div style={pstyle("font-size:12.5px; color:oklch(0.52 0.015 60); line-height:1.55;")}>{v.progressNote}</div>
          <button type="button" onClick={v.resumeLesson} style={pstyle("border:none; font:inherit; width:100%; font-size:13.5px; background:oklch(0.24 0.012 60); color:oklch(0.98 0.005 85); padding:9px 16px; border-radius:7px; text-align:center; cursor:pointer;")}>{v.resumeLabel}</button>
        </div>

        <div style={pstyle("display:flex; flex-direction:column; gap:10px;")}>
          <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Modules du parcours</div>
          {v.modules.map((m, i) => (
            <Hoverable key={i} onClick={m.onClick} style={pstyle("display:flex; align-items:baseline; gap:10px; font-size:13.5px; padding:4px 0; cursor:pointer;", { color: m.color })} hoverStyle={{ color: "oklch(0.46 0.075 55)" }}>
              <span style={pstyle("font-family:'IBM Plex Mono', monospace; font-size:11.5px; color:oklch(0.62 0.015 60);")}>{m.n}</span>
              <span>{m.title}</span>
              <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:11px; color:oklch(0.56 0.015 60);")}>{m.state}</span>
            </Hoverable>
          ))}
        </div>

        <div style={pstyle("display:flex; flex-direction:column; gap:10px; border-top:1px solid oklch(0.95 0.006 85); padding-top:20px;")}>
          <div style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Fiches liées</div>
          {v.relatedArticles.map((r, i) => (
            <Hoverable key={i} onClick={r.onClick} style={pstyle("font-size:13.5px; color:oklch(0.4 0.015 60); cursor:pointer;")} hoverStyle={{ color: "oklch(0.46 0.075 55)" }}>{r.title}</Hoverable>
          ))}
        </div>
      </aside>
    </div>
  );
}
